import React, { useState, useEffect } from 'react'
import HLServerSearchListDialog from '../../GenericComponents/hlServerSearchListDialog'
import copyExistingCallbacks from '../../GenericComponents/copyExistingVUCallback'

interface CopyExistingVUDialogProps {
    isOpen: boolean
    onClose: () => void
    WorkspaceId: number
}

const CopyExistingVUDialog: React.FC<CopyExistingVUDialogProps> = ({
    isOpen,
    onClose,
    WorkspaceId
}) => {
    return (
        
        <HLServerSearchListDialog
            isOpen={isOpen}
            onClose={onClose}
            callbacks={copyExistingCallbacks(WorkspaceId)}
            searchListType="RadioButton"
        ></HLServerSearchListDialog>
    )
}

export default CopyExistingVUDialog
